<div class="wrapper-content flex-column">
  <!-- Header -->
  <div class="flex justify-content-between align-items-center my-4 ">
    <a routerLink="/">
      <picture>
        <source media="(width < 800px)" srcset="assets/img/icons-principal/logo-header-main-responsive.png">
        <source media="(width >= 800px)" srcset="assets/img/icons-principal/logo-header-main.png">
        <img class=" logo_main_header" src="assets/img/icons-principal/logo-header-main.png"
             draggable="false" alt="Portal de Tramites Gobernacion del Magdalena"/>
      </picture>
    </a>
    <div>
      <picture>
        <source media="(width >= 800px)" srcset="assets/img/icons-principal/logo-tramitfly.png"/>
        <source media="(800px > width >= 730px)" srcset="assets/img/icons-principal/logo-tramitfly-responsive.png"/>
        <source media="(729px >= width > 500px)" srcset="assets/img/icons-principal/ico-normal-tramitfly-2x.png"/>
        <source media="( 499px >= width )" srcset="assets/img/icons-principal/ico-normal-tramitfly.png"/>
        <img src="assets/img/icons-principal/logo-tramitfly.png" draggable="false" class="logo_app"
             alt="Logo TramitFly"/>
      </picture>

    </div>
  </div>

  <!-- Hero Section -->
  <div class="flex flex-column md:flex-row align-items-center justify-content-between md:ml-7" style="max-width:671px">
    <div class="md:w-full">
      <h3
        class="color-blue-2 font-18 font-bold text-left mb-1">{{ translations.header || 'Bienvenido al Sistema de PQRSDF del Portal de Trámites' }}</h3>
      <p class="font-18 text-left app-text-gray mt-1 my-5 md:my-auto" >
        {{ translations.subHeader || 'Registre de acuerdo a su solicitud, sus peticiones, quejas, reclamos, sugerencias, denuncias y felicitaciones de manera fácil y rápida. Contamos con tu opinión.' }}
      </p>
      <h3
        class="title-blue font-23 font-roboto-condensed mb-1 font-normal">{{ translations.titleSeguimiento || 'Haga seguimiento a su PQRSD:' }}</h3>
      <div class=" border-outline-blue-light bg-white container-input-rounded md:w-7 w-fit  mb-4">
        <div class="input-text  inline-flex md:border-none w-full">
          <div class="border-circle container-icon ">
            <i class="text-gray-500 pi pi-hashtag"></i>
          </div>
          <input pInputText type="text" class="input-text-gray w-full font-18 font-normal"
                 [(ngModel)]="radicado" (keydown.enter)="buscar()" [placeholder]="translations?.placeholderRadicado"/>
        </div>
        <div class="inline-flex ">
          <button pButton class="search bg-blue-light" (click)="buscar()"
                  type="button">
            <span class="title-blue m-0">{{ translations?.btnVer }}</span>
            <svg-loader name="ico-normal-tramitfly-white" [containerClass]="'blue-dark'"/>
          </button>
        </div>
      </div>
    </div>
    <div class=" md:block absolute left-0 right-0 top-0 container-img-bg">
      <picture>
        <source media="(width >= 800px)" srcset="assets/img/icons-principal/pqrsd-3.webp">
        <source media="(width < 800px)" srcset="assets/img/icons-principal/bg-woman.webp">
        <img src="assets/img/icons-principal/pqrsd-3.webp" alt="fondo" class="w-full h-8" draggable="false"
             style=" max-height: 444px;"/>
      </picture>

    </div>
  </div>

  <!-- Definiciones de PQRSDF -->
  <div class="grid  md:ml-7 xl:ml lg:ml-7 md:mr-0 sm:mx-1 ">
    <div class="col-12 sm:ml-5 md:ml-0  lg:px-0">
      <h3 class="title-blue mt-3 mb-4 font-23 mb-0 lg:px-0 lg:mx-0 font-roboto-condensed font-normal">
        {{ translations.tituloTipos || 'Para hacer su solicitud, tenga en cuenta estas definiciones:' }}
      </h3>
    </div>

    @defer {
      @for (item of cards$ | async; track $index) {
        <div class="col-11 mx-auto sm:ml-2 md:px-0 sm:mx-0" [ngClass]="item.classContainer">
          <div class="app-card border-2 relative  gap-0 ml-3 md:ml-0">
            <div class="flex align-items-center justify-content-center
          app-card border-gradient card-icon absolute">
              <img [src]="item.img" [alt]="item.alt" draggable="false" fetchpriority="high">
            </div>
            <div class="flex align-items-center justify-content-between">
              <div class="flex align-items-center gap-3">
                <a [routerLink]="item.link" class="no-underline">
                  <h6 class="color-blue-2 font-18 font-bold my-0"> {{ item.title }}</h6>
                </a>
                <p class="brand-blue-light px-1 border-round font-13">{{ item.tag }}</p>
              </div>
            </div>
            <p class="mt-2 app-text-gray font-12"
               style="line-height:18px;">
              {{ item.description }}
            </p>
          </div>
        </div>

      }
    } @placeholder (minimum 100ms) {
      @for (item of classContainers; track $index) {
        <div class="col-11 mx-auto sm:ml-2 md:px-0 sm:mx-0" [ngClass]="item">
          <p-skeleton height="7rem"/>
        </div>
      }

    }

  </div>
</div>
<app-footer class=" md:absolute bottom-0 w-full"/>
